import axios from "axios";

export const handleGetRequest = (URL, callParams)=>{
    let handleGetPromise = new Promise((resolve, reject)=>{
        axios({
            method: 'GET',
            url: URL,
            params : callParams ? {...callParams} : {},
        }).then(res=>{
            //console.log('res',res);
            if(res.data?.status === 200)
                resolve(res.data);
            else if(res.status === 200)
                resolve(res.data)
            else 
                reject(res.data['message'] || res.data);
            
        }).catch(err=>{
            reject(err);
        })
    });

    return handleGetPromise;

}


